import { FC } from "react";
import {
  WidgetConfig,
  WidgetType,
  isDynamicListConfig,
  isFavoriteDocumentsConfig,
  isFavoriteSearchesConfig,
  isRecentSearchesConfig,
  isShortcutConfig,
  isStaticListConfig,
  isSubscriptionsConfig,
} from "@/models/dashboard/WidgetConfig";
import DynamicListConfigForm from "./DynamicListConfigForm";
import StaticListConfigForm from "./StaticListConfigForm";
import ShortcutConfigForm from "./ShortcutConfigForm";
import FavoriteDocumentsConfigForm from "./FavoriteDocumentsConfigForm";
import FavoriteSearchesConfigForm from "./FavoriteSearchesConfigForm";
import SubscriptionsConfigForm from "./SubscriptionsConfigForm";
import RecentSearchesConfigForm from "./RecentSearchesConfigForm";

interface WidgetConfigFieldsProps {
  type: WidgetType;
  config: WidgetConfig;
  onChange: (config: WidgetConfig) => void;
  /** Reports input that is typed but not yet in the config (a half-added shortcut). */
  onDraftStateChange?: (hasDraft: boolean) => void;
}

/** The type-specific settings of a widget; null for a type that has none. */
const WidgetConfigFields: FC<WidgetConfigFieldsProps> = ({
  type,
  config,
  onChange,
  onDraftStateChange,
}) => {
  switch (type) {
    case "dynamic-list":
      return isDynamicListConfig(config) ? (
        <DynamicListConfigForm config={config} onChange={onChange} />
      ) : null;
    case "static-list":
      return isStaticListConfig(config) ? (
        <StaticListConfigForm config={config} onChange={onChange} />
      ) : null;
    case "shortcut":
      return isShortcutConfig(config) ? (
        <ShortcutConfigForm
          config={config}
          onChange={onChange}
          onDraftStateChange={onDraftStateChange}
        />
      ) : null;
    case "favorite-documents":
      return isFavoriteDocumentsConfig(config) ? (
        <FavoriteDocumentsConfigForm config={config} onChange={onChange} />
      ) : null;
    case "favorite-searches":
      return isFavoriteSearchesConfig(config) ? (
        <FavoriteSearchesConfigForm config={config} onChange={onChange} />
      ) : null;
    case "subscriptions":
      return isSubscriptionsConfig(config) ? (
        <SubscriptionsConfigForm config={config} onChange={onChange} />
      ) : null;
    case "recent-searches":
      return isRecentSearchesConfig(config) ? (
        <RecentSearchesConfigForm config={config} onChange={onChange} />
      ) : null;
    case "notifications":
      return null;
  }
};

export default WidgetConfigFields;
